import React from 'react';
import { Grid, MenuItem, Select } from '@mui/material';
import { exchangeRates } from 'src/const';

const CurrencyChangeMenu = ({
  currency,
  setCurrency,
  fullWidth,
  darkTheme,
}: {
  currency: string;
  setCurrency;
  fullWidth?: boolean;
  darkTheme?: boolean;
}) => {
  const changeCurrency = event => {
    setCurrency(event.target.value);
  };

  const fullWidthStyle={
    width: fullWidth ? '100%' : 'auto',
  }

  const darkModeStyle={
    ...fullWidthStyle,
    '& svg': {
      color: '#fff',
    },
    '& .MuiSelect-select': {
      color: '#fff',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fff',
    }
  }

  return (
    <MenuItem sx={darkTheme? darkModeStyle : fullWidthStyle}>
      <Grid container alignItems="center">
        <Grid item xs={12} sx={{ position: 'relative' }}>
          <Select
            labelId="currency-select-label"
            id="currency-select"
            variant="outlined"
            value={currency}
            onChange={changeCurrency}
            sx={{ width: fullWidth? '100%' : 100, height: 40 }}
          >
            {Object.keys(exchangeRates).map((type, index) => (
              <MenuItem key={index} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
    </MenuItem>
  );
};

export default CurrencyChangeMenu;
